import React from 'react';
import { Colors, FontSize, Spacing } from '@common/tokens';
import { Icon } from '@common/components';

const ALLOWED_TAGS_PATTERN =
  /^[^<]*(<(b|strong|em|a|br|\/b|\/strong|\/em|\/a)\b[^>]*>[^<]*)*$/i;

const containsOnlyAllowedHtml = (html: string): boolean =>
  ALLOWED_TAGS_PATTERN.test(html);

export const SystemMessageBanner = ({
  id,
  body,
  onDismiss,
}: {
  id: string;
  body: string;
  onDismiss: (id: string) => void;
}) => {
  if (!containsOnlyAllowedHtml(body)) {
    console.error(
      'SystemMessageBanner: body contains disallowed HTML tags and will not be rendered.'
    );
    return null;
  }

  return (
    <section className="wk-system-message-banner" role="status">
      <span dangerouslySetInnerHTML={{ __html: body }} />
      <button
        className="wk-system-message-banner__close"
        onClick={() => onDismiss(id)}
        aria-label="Dismiss banner"
        type="button"
      >
        <Icon icon="xMark" kind="light" />
      </button>
      <style jsx>{`
        .wk-system-message-banner {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: ${Spacing.sm}px;
          padding: ${Spacing.sm}px ${Spacing.lg}px;
          background: ${Colors.skyHyperLight};
          border-bottom: 1px solid ${Colors.skyLightest};
          color: ${Colors.midnightDarkest};
          font-size: ${FontSize.sm};
          line-height: 1.4;
          min-height: 42px;
        }
        .wk-system-message-banner__close {
          background: none;
          border: none;
          cursor: pointer;
          color: ${Colors.midnightLighter};
          padding: ${Spacing.xs}px;
          display: flex;
          align-items: center;
        }
      `}</style>
    </section>
  );
};
